// import Swiper from "swiper/bundle";
// // import Swiper from "swiper";
// import "swiper/swiper-bundle.css";

import { gsap } from "gsap";

export function main() {
  document.getElementById('hamburger').addEventListener("click", function () {
    document.getElementById('hamburger').classList.toggle('open')
    document.getElementById('slide').classList.toggle('show')
  })
  
  // ホバーする要素を取得します
  const navItem = document.getElementById('headerService');
  
  // ドロップダウンメニューの要素を取得します
  const dropdownMenu = document.querySelector('.header__dropdownMenu');
  
  // 各navItemに対してイベントリスナーを追加します
  
    navItem.addEventListener('mouseover', () => {
      dropdownMenu.classList.add('show');
    });
  
    navItem.addEventListener('mouseout', () => {
      dropdownMenu.classList.remove('show');
    });
  
    // dropdownMenuに対してイベントリスナーを追加します
  dropdownMenu.addEventListener('mouseover', () => {
    dropdownMenu.classList.add('show');
  });
  
  dropdownMenu.addEventListener('mouseout', () => {
    dropdownMenu.classList.remove('show');
  });
  
  
  if (document.querySelector(".faq__question") !== null) {
    document.querySelectorAll(".faq__question").forEach(e => {
      e.addEventListener("click", () => {
        e.classList.toggle("open");
        const answer = e.nextElementSibling;
        if (e.classList.contains("open")) {
          answer.style.height = answer.scrollHeight + 'px';
        }
        else {
          answer.style.height = "0";
        }
      });
    }
    );
  }
  
  if (document.querySelector('.movieExample__content') !== null) {
    document.querySelectorAll('.movieExample__content').forEach(e => {
      e.addEventListener('click', () => {
        console.log(e)
        e.querySelector('.movieExample__modal').classList.add('open');
        document.querySelector('.modal-back').classList.add('open');
      }
      );});
  };
  
  if (document.querySelector('.movieExample__content') !== null) {
    document.querySelector(".modal-back").addEventListener('click', () => {
      document.querySelectorAll('.movieExample__modal').forEach(e => {
        if (e.classList.contains('open')) {
          e.classList.remove('open');
        }
      });
        document.querySelector('.modal-back').classList.remove('open');
      }
      );
  };
  
  
  
  if (document.getElementById("caseSlider") !== null) {
    const caseSlider = new Swiper("#caseSlider", {
      loop: true,
      centeredSlides: true,
      slidesPerView: 1,
      speed: 4000,
      spaceBetween: 20,
      loopAdditionalSlides: 5,
      autoplay: {
        delay: 4000,
      },
    });
  }
  
  if (document.getElementById("logoSliderTop") !== null) {
    const topSpeed = window.innerWidth <= 768 ? 26000 : 60000;
    const logoSliderTop = new Swiper("#logoSliderTop", {
      loop: true,
      speed: topSpeed,
      // slidesPerView: '1',
      centeredSlides: true,
      loopAdditionalSlides: 3,
      allowTouchMove: false, // スワイプ無効
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
    });
  }
  
  if (document.getElementById("logoSliderBottom") !== null) {
    const bottomSpeed = window.innerWidth <= 768 ? 18000 : 65000;
    const logoSliderTop = new Swiper("#logoSliderBottom", {
      loop: true,
      speed: bottomSpeed,
      // slidesPerView: '1',
      centeredSlides: true,
      loopAdditionalSlides: 3,
      allowTouchMove: false, // スワイプ無効
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        reverseDirection: true, // 逆再生
      },
    });
  }
  
  
  if (document.querySelector('.contactLink') !== null || document.querySelector('requestLink') !== null) {
    document.querySelectorAll('.contactLink').forEach(contactLink => {
      
      contactLink.addEventListener('click', (e) => {
        e.preventDefault();
        sessionStorage.setItem('contactType', '無料相談');
        
        location.href = e.currentTarget.href;
      });
    });
  
    document.querySelectorAll('.requestLink').forEach(requestLink => {
      
      requestLink.addEventListener('click', (e) => {
        e.preventDefault();
        sessionStorage.setItem('contactType', '資料請求');
        console.log(e.currentTarget.href)
  
        location.href = e.currentTarget.href;
      });
    });
  }
  
  
  
  if (document.getElementById('contact') !== null) {
    const contact = document.getElementById('contact');
  
    let contactLinkValue = sessionStorage.getItem('contactType');
    console.log(contactLinkValue);
  
    const contactType = document.getElementById('type');
    
    if (contactLinkValue === "無料相談") {
      type.value = "無料相談";
  
    }
    else if (contactLinkValue === "資料請求") {
      type.value = "資料請求";
    }
    else {
      type.value = "無料相談";
    }
  
    sessionStorage.removeItem('contactType');
    
  }
  
  if (document.getElementById("top") !== null) {
    const twitterEmbed = document.getElementsByClassName('twitter-tweet');
    const instaEmbed = document.getElementsByClassName('instagram-media');
  
    try {
      if (twitterEmbed.length !== 0) {
        Defer.js('//platform.twitter.com/widgets.js', 'widgets-js', 1000);
      }
      if (instaEmbed.length !== 0) {
        Defer.js('//www.instagram.com/embed.js', 'embed-js', 1000);
      }
    } catch (error) {
      console.log(error);
    }
  }
  
  if (document.getElementById("movie") !== null) {
    Defer.dom("#movie iframe", 0, "youtube-loaded");
  }
}


